module.exports = __webpack_public_path__ + "static/img/checkbox-rounded-unchecked.f1af3dc.png";